// Herkunft: https://blocks.tremor.so/blocks/page-shells
// Angelehnt an Page Shell 04/05 — Titel, Beschreibung, Aktion, optionale Tabs.
// Die Schriftgrade folgen seit der Abstimmung dem Entwurf „Cubic Studio":
// Überschrift 22px/700, Beschreibung 14px in Grau. Der Entwurf setzt 22px auf
// fünf Bildschirmen und 26px nur für den Gruß auf der Übersicht.

import type { ReactNode } from "react";
import { cx } from "@/lib/utils";

export function Seitenkopf({
  titel,
  beschreibung,
  aktion,
  tabs,
  className,
}: {
  titel: string;
  beschreibung?: string;
  aktion?: ReactNode;
  tabs?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx("space-y-4", className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 space-y-1">
          {/*
            Laufweite: Große Grade öffnen zu weit. Ohne das Minus zerfällt
            „Aufgaben" bei 22px sichtbar in Einzelbuchstaben. `text-balance`
            verhindert, dass ein langer Titel mit einem einzelnen Wort in der
            zweiten Zeile endet.
          */}
          <h1 className="text-balance text-[22px] font-bold leading-tight tracking-titel text-gray-900 dark:text-gray-50">
            {titel}
          </h1>
          {beschreibung ? (
            <p className="max-w-prose text-sm text-gray-600 dark:text-gray-400">
              {beschreibung}
            </p>
          ) : null}
        </div>
        {aktion ? (
          <div className="flex shrink-0 items-center gap-2">{aktion}</div>
        ) : null}
      </div>
      {tabs}
    </div>
  );
}
